// src/api.js
import api from "./axiosConfig";

// ======================================================
// AUTH
// ======================================================

export const registerAdmin = (payload) =>
  api.post("/api/auth/register/admin", payload).then((r) => r.data);

export const registerUser = (payload) =>
  api.post("/api/auth/register/user", payload).then((r) => r.data);

export const registerChef = (payload) =>
  api.post("/api/auth/register/chef", payload).then((r) => r.data);

export const login = (payload) =>
  api.post("/api/auth/login", payload).then((r) => r.data);

export const googleLogin = (idToken) =>
  api.post("/api/auth/google", { idToken }).then((r) => r.data);


// ======================================================
// CATEGORIES
// ======================================================

export const getCategories = () =>
  api.get("/api/categories").then((r) => r.data);

export const createCategory = (data) =>
  api.post("/api/categories", data).then((r) => r.data);

export const updateCategory = (id, data) =>
  api.put(`/api/categories/${id}`, data).then((r) => r.data);

export const deleteCategory = (id) =>
  api.delete(`/api/categories/${id}`).then((r) => r.data);


// ======================================================
// MENU ITEMS
// ======================================================

// Get all menu items
export const getMenuItems = () =>
  api.get("/api/menu-items").then((r) => r.data);

// Get available menu items for POS
export const getAvailableMenuItems = () =>
  api.get("/api/menu-items/available").then((r) => r.data);

// Delete menu item
export const deleteMenuItem = (id) =>
  api.delete(`/api/menu-items/${id}`).then((r) => r.data);

// Create menu item with image
export const createMenuItem = (item, imageFile) => {

  const formData = new FormData();

  formData.append(
    "data",
    JSON.stringify(item)
  );

  if (imageFile) {
    formData.append(
      "image",
      imageFile
    );
  }

  return api
    .post(
      "/api/menu-items",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((r) => r.data);
};

// Update menu item with image
export const updateMenuItem = (
  id,
  item,
  imageFile
) => {

  const formData = new FormData();

  formData.append(
    "data",
    JSON.stringify(item)
  );

  if (imageFile) {
    formData.append(
      "image",
      imageFile
    );
  }

  return api
    .put(
      `/api/menu-items/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((r) => r.data);
};


// ======================================================
// ORDERS
// ======================================================

// Get completed/ready orders
export const getOrders = () =>
  api
    .get("/api/orders")
    .then((r) => r.data);


// ------------------------------------------------------
// Normal POS order
// ------------------------------------------------------

// export const createOrder = (payload) =>
//   api
//     .post("/api/orders", payload)
//     .then((r) => r.data);

export const createOrder = async (payload) => {
  const response = await api.post(
    "/api/orders",
    payload
  );

  return response.data;
};


// ------------------------------------------------------
// Direct POS order
// ------------------------------------------------------

/*
 IMPORTANT:

 Do NOT calculate GST here.

 Backend OrderService should calculate:

 item price
      +
 item GST
      =
 item final amount

 Example:

 Burger = ₹500
 GST 5% = ₹25
 Final = ₹525

 The backend also saves:

 Order.subtotal
 Order.taxAmount
 Order.totalAmount

 and:

 OrderItem.price
 OrderItem.taxRate
 OrderItem.taxAmount
 OrderItem.lineTotal
*/

export const createDirectOrder = (payload) =>
  api
    .post(
      "/api/orders/direct",
      payload
    )
    .then((r) => r.data);


// ------------------------------------------------------
// Delete order
// ------------------------------------------------------

export const deleteOrder = (id) =>
  api
    .delete(`/api/orders/${id}`)
    .then((r) => r.data);


// ------------------------------------------------------
// Order status
// ------------------------------------------------------

// export const updateOrderStatus = (
//   id,
//   status
// ) =>
//   api
//     .put(
//       `/api/orders/${id}/status`,
//       {
//         status,
//       }
//     )
//     .then((r) => r.data);


export const updateOrderStatus = async (
  id,
  status
) => {
  const response = await api.put(
    `/api/orders/${id}/status`,
    {
      status,
    }
  );

  return response.data;
};


// ------------------------------------------------------
// Pending orders
// ------------------------------------------------------

export const getPendingOrders = () =>
  api
    .get("/api/orders/pending")
    .then((r) => r.data);


// ------------------------------------------------------
// Kitchen orders
// ------------------------------------------------------

export const getKitchenOrders = () =>
  api
    .get("/api/orders/kitchen")
    .then((r) => r.data);

export const updateKitchenStatus = (
  orderId,
  status
) =>
  api
    .put(
      `/api/orders/${orderId}/status`,
      {
        status,
      }
    )
    .then((r) => r.data);


// ======================================================
// SINGLE ORDER
// ======================================================

export const getOrder = (id) =>
  api
    .get(`/api/orders/${id}`)
    .then((r) => r.data);


// ======================================================
// ORDER TYPE
// ======================================================

export const updateOrderType = (
  orderId,
  orderType
) =>
  api
    .put(
      `/api/orders/${orderId}/type`,
      {
        orderType,
      }
    )
    .then((r) => r.data);


// ======================================================
// ORDER NOTES
// ======================================================

export const updateOrderNotes = (
  orderId,
  specialInstructions
) =>
  api
    .put(
      `/api/orders/${orderId}/notes`,
      {
        specialInstructions,
      }
    )
    .then((r) => r.data);


// ======================================================
// ORDER ITEMS
// ======================================================

// Get order items
export const getOrderItems = (
  orderId
) =>
  api
    .get(
      `/api/orders/${orderId}/items`
    )
    .then((r) => r.data);


// Add item to order
export const addOrderItem = (
  orderId,
  menuItemId
) =>
  api
    .post(
      `/api/orders/${orderId}/items`,
      null,
      {
        params: {
          menuItemId,
        },
      }
    )
    .then((r) => r.data);


// Update quantity
export const updateOrderItem = (
  orderItemId,
  quantity
) =>
  api
    .put(
      `/api/order-items/${orderItemId}`,
      {
        quantity,
      }
    )
    .then((r) => r.data);


// Delete order item
export const deleteOrderItem = (
  orderItemId
) =>
  api
    .delete(
      `/api/order-items/${orderItemId}`
    )
    .then((r) => r.data);


// ======================================================
// RESTAURANT TABLES
// ======================================================

// Get all tables
export const getTables = () =>
  api
    .get("/api/tables")
    .then((r) => r.data);


// Get single table
export const getTable = (id) =>
  api
    .get(`/api/tables/${id}`)
    .then((r) => r.data);


// Create table
export const createTable = (table) =>
  api
    .post(
      "/api/tables",
      table
    )
    .then((r) => r.data);


// Update table
export const updateTable = (
  id,
  table
) =>
  api
    .put(
      `/api/tables/${id}`,
      table
    )
    .then((r) => r.data);


// Delete table
export const deleteTable = (id) =>
  api
    .delete(`/api/tables/${id}`)
    .then((r) => r.data);


// Update table status
export const updateTableStatus = (
  id,
  status
) =>
  api
    .put(
      `/api/tables/${id}/status`,
      null,
      {
        params: {
          status,
        },
      }
    )
    .then((r) => r.data);


// ======================================================
// TABLE ORDER
// ======================================================

export const getOrCreateTableOrder = (
  tableId
) =>
  api
    .post(
      `/api/tables/${tableId}/order`
    )
    .then((r) => r.data);


// ======================================================
// BUSINESS PROFILE
// ======================================================

export const getBusinessProfile = () =>
  api
    .get("/api/business-profile")
    .then((r) => r.data);


// Save business profile + logo
export const saveBusinessProfile = (
  form,
  logoFile
) => {

  const fd = new FormData();

  fd.append(
    "data",
    JSON.stringify({

      businessName:
        form.businessName || "",

      addressLine1:
        form.addressLine1 || "",

      addressLine2:
        form.addressLine2 || "",

      city:
        form.city || "",

      state:
        form.state || "",

      pincode:
        form.pincode || "",

      phone:
        form.phone || "",

      email:
        form.email || "",


      // ==============================
      // GST
      // ==============================

      gstEnabled:
        Boolean(form.gstEnabled),

      gstin:
        form.gstin || "",

      defaultTaxRate:
        form.defaultTaxRate === ""
          ? null
          : Number(form.defaultTaxRate),

      taxInclusive:
        Boolean(form.taxInclusive),

    })
  );

  if (logoFile) {
    fd.append(
      "logo",
      logoFile
    );
  }

  return api
    .post(
      "/api/business-profile",
      fd,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    )
    .then((r) => r.data);
};


// Get business logo
export const getBusinessLogoBlob = () =>
  api.get(
    "/api/business-profile/logo",
    {
      responseType: "blob",
    }
  );


// ======================================================
// USERS / ADMIN
// ======================================================

export const getAdminUsers = () =>
  api
    .get("/api/auth/users")
    .then((r) => r.data);

export const deleteAdminUser = (
  id
) =>
  api
    .delete(`/api/auth/users/${id}`)
    .then((r) => r.data);

export const updateUserPassword = (
  id,
  newPassword
) =>
  api
    .put(
      `/api/auth/users/${id}/password`,
      {
        newPassword,
      }
    )
    .then((r) => r.data);


// ======================================================
// DASHBOARD
// ======================================================

export const getDashboardData = () =>
  api
    .get("/api/dashboard")
    .then((r) => r.data);

export const getMonthlySales = () =>
  api
    .get("/api/dashboard/monthly-sales")
    .then((r) => r.data);


// ======================================================
// PARTIES
// ======================================================

export const getParties = () =>
  api
    .get("/api/parties")
    .then((r) => r.data);

export const createParty = (
  payload
) =>
  api
    .post(
      "/api/parties",
      payload
    )
    .then((r) => r.data);

export const updateParty = (
  id,
  payload
) =>
  api
    .put(
      `/api/parties/${id}`,
      payload
    )
    .then((r) => r.data);

export const deleteParty = (
  id
) =>
  api
    .delete(`/api/parties/${id}`)
    .then((r) => r.data);


// ======================================================
// EXPENSES
// ======================================================

export const getExpenses = () =>
  api
    .get("/api/expenses")
    .then((r) => r.data);

export const createExpense = (
  payload
) =>
  api
    .post(
      "/api/expenses",
      payload
    )
    .then((r) => r.data);

export const updateExpense = (
  id,
  payload
) =>
  api
    .put(
      `/api/expenses/${id}`,
      payload
    )
    .then((r) => r.data);

export const deleteExpense = (
  id
) =>
  api
    .delete(`/api/expenses/${id}`)
    .then((r) => r.data);


// ======================================================
// REPORTS
// ======================================================

export const getReportSummary = (
  start,
  end
) =>
  api
    .get(
      "/api/reports/summary",
      {
        params: {
          start,
          end,
        },
      }
    )
    .then((r) => r.data);


// ======================================================
// SUBSCRIPTION
// ======================================================

export const getSubscription = () =>
  api
    .get("/api/subscription")
    .then((r) => r.data);

export const createSubscription = () =>
  api
    .post("/api/subscription/create")
    .then((r) => r.data);

export const verifySubscription = (
  data
) =>
  api
    .post(
      "/api/subscription/verify",
      data
    )
    .then((r) => r.data);

export const requestRecoveryEmailOtp = async (email) => {
  const { data } = await api.post(
    "/api/auth/recovery/email/request",
    { email }
  );
  return data;
};

export const verifyRecoveryEmailOtp = async (email, code) => {
  const { data } = await api.post(
    "/api/auth/recovery/email/verify",
    { email, code }
  );
  return data;
};

export const resetRecoveredPassword = async (
  resetToken,
  newPassword
) => {
  const { data } = await api.post(
    "/api/auth/recovery/reset",
    { resetToken, newPassword }
  );
  return data;
};



export const checkoutOrder = async (orderId, payload) => {
  const response = await api.put(
    `/api/orders/${orderId}/checkout`,
    payload
  );

  return response.data;
};
